/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { Box } from "@material-ui/core";

import { GET_SUBSCRIPTIONS_LIST } from "graphql/query/admin";
import Table from "Components/Table/Table";
import { formStyles } from "./TableStyles";

const SubscriptionsList = ({
  setErrorMsg,
  actionPerformed,
  setActionPerformed,
  handleEditButtonClick,
  handleViewButtonClick,
}) => {
  const classes = formStyles();
  const [subscriptions, setSubscriptions] = useState([]);

  const { data, refetch, error, loading } = useQuery(GET_SUBSCRIPTIONS_LIST, {
    fetchPolicy: "network-only",
  });

  const setAllSubscriptions = () => {
    if (data && data.subscriptions) {
      const list = data.subscriptions
        .filter((s) => !s.isDeleted)
        .map((s) => ({
          ...s,
          isOnRazorpayLabel: s.isOnRazorpay ? "Yes" : "No",
          isActiveLabel: s.isActive ? "Active" : "Inactive",
        }));
      setSubscriptions(list);
      setErrorMsg("");
    }
  };

  useEffect(() => {
    if (actionPerformed) {
      refetch();
      setActionPerformed(false);
    }
    if (error) {
      setErrorMsg("Error in loading data !");
    }
    setAllSubscriptions();
  }, [data, actionPerformed, error]);

  const TABLE_HEAD = [
    { id: "id", flag: "id", label: "No.", alignRight: false },
    { id: "name", flag: "name", label: "Name", alignRight: false },
    { id: "slug", flag: "slug", label: "Slug", alignRight: false },
    { id: "price", flag: "price", label: "Price", alignRight: false },
    { id: "duration", flag: "duration", label: "Duration", alignRight: false },
    {
      id: "isOnRazorpayLabel",
      flag: "isOnRazorpayLabel",
      label: "On Razorpay",
      alignRight: false,
    },
    {
      id: "isActiveLabel",
      flag: "isActiveLabel",
      label: "Status",
      alignRight: false,
    },
    {
      id: "createdAt",
      flag: "createdAt",
      label: "Created At",
      alignRight: false,
    },
    {
      id: "actions",
      flag: { read: true, edit: true },
      alt: "data",
      callback: {
        handleViewButton: handleViewButtonClick,
        handleEditButton: handleEditButtonClick,
      },
      label: "Actions",
      alignRight: false,
    },
  ];

  return (
    <Box className={classes.mainContainer}>
      <Table
        error={error}
        USERLIST={subscriptions}
        TABLE_HEAD={TABLE_HEAD}
        page={0}
        noPagination
        loading={loading}
      />
    </Box>
  );
};

export default SubscriptionsList;
